var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateTable',{attrs:{"title":_vm.$t('menu.soldArticles'),"text":_vm.$t('soldArticles.description'),"name":"soldArticles","url":_vm.$listRoutes.ordersArticles,"table":_vm.soldArticles,"filters":_vm.soldArticlesFilters,"fields":_vm.fields}})
}
var staticRenderFns = []

export { render, staticRenderFns }